import { Skeleton, Td } from "@chakra-ui/react";

import { Tr } from "@chakra-ui/react";
import { useResource } from "hooks/resources/providers/resourceProvider";

type DataTableRowSkeletonProps = {
	columns: number;
	rows?: number;
};

export function DataTableRowSkeleton({
	columns,
	rows,
}: DataTableRowSkeletonProps) {
	const { pagination } = useResource<unknown>();

	const rowsCount = rows ?? pagination.pageSize;

	return (
		<>
			{Array.from({ length: rowsCount }).map((_, index) => (
				<Tr key={index}>
					{Array.from({ length: columns }).map((_, index) => (
						<Td key={index}>
							<Skeleton height="24px" />
						</Td>
					))}
				</Tr>
			))}
		</>
	);
}
